import ProjectStep from "./ProjectStep";
import TaskStep from "./TaskStep";
import MemberStep from "./MemberStep";

export default function Steps() {
  return [ProjectStep(), TaskStep(), MemberStep()];
}
